
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.997","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.547 12.099a3.45 3.45 0 00-2.588 1.19l-6.116-3.053a3.45 3.45 0 000-1.449l6.116-3.054a3.45 3.45 0 10-.863-2.26 3.33 3.33 0 00.078.725L6.058 7.252a3.45 3.45 0 100 4.52l6.116 3.054a3.33 3.33 0 00-.078.725 3.45 3.45 0 103.45-3.45z","fill":"#607d8b"}})])
          )
        }
      }
    